import $ from 'jquery';

const quickLinks = () => {
    const $htmlAndBody = $('body,html');
    const $overlay = $('.js-quick-links-overlay');

    $('.js-quick-links-open').on('click', () => {
        $htmlAndBody.addClass('u-scroll-forbid');
        $overlay.height('100%');
    });

    $('.js-quick-links-link').each(function() {
        $(this).on('click', () => {
            $htmlAndBody.removeClass('u-scroll-forbid');
            $overlay.height(0);
        });
    });

    $('.js-quick-links-close').on('click', () => {
        $htmlAndBody.removeClass('u-scroll-forbid');
        $overlay.height(0);
    });
};

// doc ready
$(() => {
    quickLinks();
});
